import styled from "styled-components";
import { colors } from "../styles/constants";

const Root = styled.div`
    font-size: 14px;
    color: ${colors.text};
`;

export default Root;
